import { render, staticRenderFns } from "./th-primary.vue?vue&type=template&id=807b2e68&scoped=true"
import script from "./th-primary.vue?vue&type=script&lang=js"
export * from "./th-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807b2e68",
  null
  
)

export default component.exports